var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.08197C0 0.484199 0.485646 0 1.08424 0H10.9158C11.5144 0 12 0.484199 12 1.08197C12 1.67974 11.5144 2.16393 10.9158 2.16393H1.08424C0.485646 2.16393 0 1.67974 0 1.08197Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 5.40223 0.485646 4.91803 1.08424 4.91803H10.9158C11.5144 4.91803 12 5.40223 12 6C12 6.59777 11.5144 7.08197 10.9158 7.08197H1.08424C0.485646 7.08197 0 6.59777 0 6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.918C0 10.3203 0.485646 9.83607 1.08424 9.83607H10.9158C11.5144 9.83607 12 10.3203 12 10.918C12 11.5158 11.5144 12 10.9158 12H1.08424C0.485646 12 0 11.5158 0 10.918Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarMenu);
export default __webpack_public_path__ + "static/media/BarMenu.11d4565f1a7036b8d11416759f1b452a.svg";
export { ForwardRef as ReactComponent };